const SecurityView = () => {
  return (
    <div>
      {/* two step verification part */}
      <div className="mt-10">
        <div className=" flex border-green bg-white rounded-lg border-[1px] items-center justify-between px-4 mt-2">
          <p className="w-4/5 overflow-hidden mr-2">
            <h6>Two Step Verification</h6>
            <div className="text-gray-200">Secure your account with extra verification</div>
          </p>
          <button>toggle</button>
        </div>
      </div>
      {/* Email  verification part */}
      <div className="mt-10">
        <div className=" flex border-green bg-white rounded-lg border-[1px] items-center justify-between px-4 mt-2">
          <p className="w-4/5 overflow-hidden mr-2">
            <h6>Email Verification</h6>
            <div className="text-gray-200">Use email as extra verification to your pin</div>
          </p>
          <button>toggle</button>
        </div>
      </div>
      {/* Phone number verification part */}
      <div className="mt-10">
        <div className=" flex border-green bg-white rounded-lg border-[1px] items-center justify-between px-4 mt-2">
          <p className="w-4/5 overflow-hidden mr-2">
            <h6>Phone number Verification</h6>
            <div className="text-gray-200">Use phone number as extra verification to your pin</div>
          </p>
          <button>toggle</button>
        </div>
      </div>
    </div>
    // <div className="border-2 border-green-600 rounded-lg mb-3">
  );
};

export default SecurityView;
